module.exports = __webpack_public_path__ + "img/diagnosis-1.97a0ca14.png";